import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { NAV_LINKS, BRAND } from "@/lib/siteData";

const LEGAL = ["Privacy Policy", "Terms", "Cookies"];

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-navy-deep">
      <div className="absolute inset-0 grid-pattern opacity-20" />
      <div className="relative mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* Brand */}
          <div className="order-1 md:col-span-5">
            <Logo variant="dark" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-navy-muted">
              Beautiful business websites paired with an easy management system — so you stay in
              control, always.
            </p>
            <p className="mt-6 font-display text-sm font-semibold uppercase tracking-[0.28em] text-techblue-glow">
              {BRAND.tagline}
            </p>
          </div>

          {/* Nav */}
          <div className="order-3 md:order-2 md:col-span-4">
            <h4 className="font-display text-sm font-semibold text-navy-foreground">Explore</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-navy-muted transition-colors hover:text-navy-foreground"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="order-2 md:order-3 md:col-span-3">
            <h4 className="font-display text-sm font-semibold text-navy-foreground">Get in touch</h4>
            <button
              type="button"
              onClick={() =>
                document.getElementById("demo")?.scrollIntoView({ behavior: "smooth" })
              }
              className="mt-4 flex w-full items-start gap-2.5 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-left text-navy-foreground transition-colors hover:bg-white/10"
            >
              <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-gradient-blue">
                <Mail className="h-4 w-4 text-primary-foreground" />
              </span>
              <span className="min-w-0">
                <span className="block text-[10px] uppercase tracking-wider text-navy-muted">Email us</span>
                <span className="block break-all font-display text-xs font-bold sm:text-sm">{BRAND.email}</span>
              </span>
            </button>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-navy-muted">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {LEGAL.map((item) => (
              <li key={item}>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="text-xs text-navy-muted transition-colors hover:text-navy-foreground"
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};
